function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

function SvgDownloadDetail(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 22 22"
  }, props), React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    style: {
      fill: "#848890"
    }
  }), React.createElement("path", {
    d: "M17.67,12v2.33a1.45,1.45,0,0,1-1.44,1.45H5.77a1.45,1.45,0,0,1-1.44-1.45V12",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), React.createElement("line", {
    x1: 11,
    y1: 4.18,
    x2: 11,
    y2: 12,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), React.createElement("polyline", {
    points: "8.68 9.68 11 12 13.32 9.68",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}

export default __webpack_public_path__ + "static/media/downloadDetail.be842b29.svg";
export { SvgDownloadDetail as ReactComponent };